import React, { ReactNode } from "react";

interface CardDataStatsProps {
  title: string;
  total: string;
  icon: string;
  rate?: string;
  levelUp?: boolean;
  levelDown?: boolean;
  loading?: boolean;
  children?: ReactNode;
}

const CardDataStats: React.FC<CardDataStatsProps> = ({
  title,
  total,
  rate,
  icon,
  levelUp,
  levelDown,
  loading,
}) => {
  return (
    <div className="border-stroke px-7.5 shadow-default dark:border-strokedark dark:bg-boxdark rounded-sm border bg-white py-6">
      <div className="bg-meta-2 dark:bg-meta-4 text-secondary border-primary/30 flex h-14 w-14 items-center justify-center rounded-full border-2">
        {loading ? (
          <i className="fa-solid fa-spinner animate-spin text-gray-500" />
        ) : (
          <i className={`${icon} text-lg`} />
        )}
      </div>

      <div className="mt-4 flex items-end justify-between">
        <div>
          <h4 className="text-title-md font-bold text-black dark:text-white">
            {loading ? (
              <span className="block h-5 w-16 animate-pulse rounded bg-gray-300 dark:bg-gray-700" />
            ) : (
              total
            )}
          </h4>
          <span className="text-sm font-medium">
            {loading ? (
              <span className="block h-4 w-24 animate-pulse rounded bg-gray-300 dark:bg-gray-700" />
            ) : (
              title
            )}
          </span>
        </div>

        <span
          className={`flex items-center gap-1 text-sm font-medium ${
            levelUp ? "text-meta-3" : ""
          } ${levelDown ? "text-meta-5" : ""}`}
        >
          {loading ? (
            <span className="block h-4 w-12 animate-pulse rounded bg-gray-300 dark:bg-gray-700" />
          ) : (
            <>
              {rate}
              {levelUp && <i className="fas fa-arrow-up text-meta-3" />}
              {levelDown && <i className="fas fa-arrow-down text-meta-5" />}
            </>
          )}
        </span>
      </div>
    </div>
  );
};

export default CardDataStats;
